import { render } from "./BookingHelp.vue?vue&type=template&id=0788f3a6&scoped=true"
import script from "./BookingHelp.vue?vue&type=script&lang=js"
export * from "./BookingHelp.vue?vue&type=script&lang=js"

import "./BookingHelp.vue?vue&type=style&index=0&id=0788f3a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0788f3a6"]])

export default __exports__